const TYPE = "ROCKY_MULTIPLE";
export const START_MULTIPLE_MODELING = `${TYPE}/start_multiple__modeling`;